import PortfolioItemViewCardWithPageOverlay from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemViewCardWithPageOverlay';
import ChallengeContentWrapper from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContentWrapper';
import TaskContext from '@/components/ChallengePortfolio/NormalView/Task/TaskView/TaskContext';
import TaskHeader from '@/components/ChallengePortfolio/NormalView/Task/TaskView/TaskHeader';
import TaskInfo from '@/components/ChallengePortfolio/NormalView/Task/TaskView/TaskInfo';
import MobilePhaseSelect from '@/components/ChallengePortfolio/NormalView/Task/TaskView/MobilePhaseSelect';
import ChallengeNameBar from './ChallengeNameBar';
import { type SetComplexImmerStateAction, type Task } from '@/lib/types';
import ChallengeColorBar, {
  CHALLENGE_NULL_COLOR,
} from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeColorBar';
import TaskPortfolioItemContextProvider from '@/components/ChallengePortfolio/NormalView/Task/TaskView/TaskPortfolioItemContextProvider';
import PortfolioItemFields from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import PortfolioItemThumbnailHeader from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemThumbnailHeader';
import ChallengeContentOuterWrapper from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContentOuterWrapper';
import { PortfolioItemCloseBlockingContextProvider } from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemCloseBlockingContext';

type CustomTaskViewProps = {
  task: Task;
  setTask: SetComplexImmerStateAction<Task>;
  onClose: () => void;
};

const CustomTaskView = ({ task, setTask, onClose }: CustomTaskViewProps) => (
  <PortfolioItemCloseBlockingContextProvider>
    <PortfolioItemViewCardWithPageOverlay variant="task" onClose={onClose}>
      <TaskContext.Provider value={[task, setTask]}>
        <TaskPortfolioItemContextProvider>
          <ChallengeContentOuterWrapper>
            <PortfolioItemThumbnailHeader />
            {task.color !== null && task.color !== CHALLENGE_NULL_COLOR && (
              <ChallengeColorBar challengeColor={task.color} />
            )}
            {task.challenge.name !== null && <ChallengeNameBar />}
            <ChallengeContentWrapper>
              <TaskHeader />
              <TaskInfo />
              <MobilePhaseSelect />
              <PortfolioItemFields modelType={ModelType.TASK} />
            </ChallengeContentWrapper>
          </ChallengeContentOuterWrapper>
        </TaskPortfolioItemContextProvider>
      </TaskContext.Provider>
    </PortfolioItemViewCardWithPageOverlay>
  </PortfolioItemCloseBlockingContextProvider>
);

export default CustomTaskView;
